export default "__VITE_ASSET__13a982b0__"